import React, { useState, useEffect  } from 'react';
import { useParams } from 'react-router-dom';
import { withRouter } from '../helpers/withRouter';
import { useNavigate } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import { BlogBBPLink } from '../helpers/Common';
import { LoaderMask } from '../helpers/LoaderMask';
import axios from 'axios';
import PropTypes from 'prop-types';
import Sharebar from '../blocks/Sharebar';
import Relateds from '../blocks/Relateds';
import TimeDeEspecialistas from '../blocks/TimeDeEspecialistas';
import PerguntasFrequentes from '../../scripts/pages/PerguntasFrequentes.js'
import Accordion from '../helpers/Accordion.js';
import image from '../../assets/images/hero-element.png';
import sharebar from '../blocks/Sharebar.js'

const SingleSeguranca = ( props ) => {

    const navigate = useNavigate();

    const { itemID } = useParams();

    const
        [ item, setItem ] = useState(false),
        [ isLoaded, setLoaded ] = useState(false),
        mask = new LoaderMask()
    ;

    const voltar = () => {
        navigate(-1); // volta uma página no histórico, equivalente ao botão "voltar" do navegador
    };

    const getData = async ( slug ) => {

        const SERVER_URL = process.env.REACT_APP_SERVER_URL;
        mask.open();

        try {
            // Request post
            axios.get( SERVER_URL + 'wp-json/wp/v2/artigos/?slug=' + slug )
                .then(res => {
                    setItem( res.data.shift() );
                    setLoaded( true );
                })
                .catch( err => console.log( err ) )
            ;
        }
        catch( error ){
            console.info('error');
            console.log(error);
        }
        finally {
            mask.close();
        }
        
    }

    useEffect(() => {
        getData( itemID );
    }, [ itemID ] )


    if( !item || !isLoaded ){
        return null;
    }

    // With media
    const withMedia = item.custom.image || item.custom.video;

    // BASE url
    const share_url = `${process.env.REACT_APP_API_URL}/ciberseguranca/artigo/${itemID}`;

    // Adjacents
    var prev_url = false, next_url = false;
    if( item.adjacents ){
        prev_url = item.adjacents.prev ? `/ciberseguranca/artigo/${item.adjacents.prev.slug}` : false;
        next_url = item.adjacents.next ? `/ciberseguranca/artigo/${item.adjacents.next.slug}` : false;
    }
    

    // Helmet meta
    var ogMeta = [
        {"property": "og:title", "content": item.title.rendred},
        {"property": "twitter:title", "content": window.location.href}
    ];
    if( item.custom.image ){
        ogMeta.push({"property": "og:image", "content": item.custom.image});
        ogMeta.push({"property": "twitter:card", "content": "summary_large_image"});
        ogMeta.push({"property": "twitter:image", "content": item.custom.image});
    }
    
    // Trimed title
    const titlePeaces = item.title.rendered.split( ' ' );
    const trimmed = ( titlePeaces.length > 4 ? titlePeaces.slice( 0, 4 ).join( ' ' ) + '...' : item.title.rendered );

    // Renderize
    return(
        <React.Fragment>

            <Helmet meta={ogMeta}>
                <title>{ item.title.rendered  + ' | BB Previdência' }</title>
            </Helmet>
            
            <article className={ 'single-post seguranca' + ( /*withMedia*/ 1 === 2 ? ' wiht-media' : '' ) }>
                
                <div>

                    {withMedia && 
                    <div className="media-wrapper">
                        { item.custom.video && 
                        <div className="video-wrapper">
                            <iframe width="560" height="315" src={`https://www.youtube.com/embed/${item.custom.video}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>}
                        { ( !item.custom.video && item.custom.image ) && 
                        <img src={item.custom.image} alt={item.post_title} /> }
                    </div>}

                    <div className="content">

                        <header>
                            <button className={'styled size--2 back mobile'} onClick={history.goBack} title="Voltar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11.995" height="12.01" viewBox="0 0 11.995 12.01"><path id="Arrow" d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1.034,1.034,0,0,0,0,1.42l5,5a1,1,0,1,0,1.42-1.42L9.41,13H17a1,1,0,0,0,0-2Z" transform="translate(-6.005 -5.996)" fill="#0059a5"/></svg>
                                <span>Voltar</span>
                            </button>
                            {/* <h2><mark>{item.post_title}</mark></h2> */}
                            <h2>{item.title.rendered}</h2>
                            <nav className="crumbs">
                                <NavLink to="/" title="BB Previdência">
                                    Institucional
                                </NavLink>
                                <span>&gt;</span>
                                <NavLink to={"/ciberseguranca"} title="Ciber Segurança">
                                    Ciber Segurança
                                </NavLink>
                                <span>&gt;</span>
                                <em>{trimmed}</em>
                            </nav>
                        </header>
                        <div className="texts" >
                            <span dangerouslySetInnerHTML={{ __html: item.content.rendered }} />
                        </div>
                        {( item.custom.video && item.custom.image ) &&
                        <div className='image'>
                            <picture>
                                <img src={item.custom.image} alt="" />
                            </picture>
                        </div>}

                        {item.custom.duvidas &&
                        <div className="main-duvidas">
                            <h2>Principais Dúvidas:</h2>
                            <Accordion items={item.custom.duvidas} />
                        </div>}
                        
                        <footer>
                            <button className={'styled size--2 back'} onClick={voltar} title="Voltar">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11.995" height="12.01" viewBox="0 0 11.995 12.01"><path id="Arrow" d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1.034,1.034,0,0,0,0,1.42l5,5a1,1,0,1,0,1.42-1.42L9.41,13H17a1,1,0,0,0,0-2Z" transform="translate(-6.005 -5.996)" fill="#0059a5"/></svg>
                                <span>Voltar</span>
                            </button>
                            <Sharebar url={share_url} title={item.title.rendered} />
                        </footer>                        
                        
                    </div>

                </div>

                {item.adjacents &&
                <nav className="adjacents">
                    <span>
                        {prev_url &&
                        <NavLink to={prev_url} className="previous" title={item.adjacents.prev.title}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24"><path id="Left" d="M8.745,18.733l10.364,10.03a1.776,1.776,0,0,0,2.545,0h0a1.714,1.714,0,0,0,0-2.507L12.745,17.3l8.909-8.955a1.714,1.714,0,0,0,0-2.507,1.776,1.776,0,0,0-2.545,0L8.745,15.867a2.155,2.155,0,0,0,0,2.866Z" transform="translate(-8.2 -5.3)" fill="#0059a5"/></svg>
                            <strong>{item.adjacents.prev.title}</strong>
                        </NavLink>}
                    </span>
                    <span>
                        {next_url &&
                        <NavLink to={next_url} className="next" title={item.adjacents.next.title}>
                            <strong>{item.adjacents.next.title}</strong>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24"><path id="Left" d="M8.745,18.733l10.364,10.03a1.776,1.776,0,0,0,2.545,0h0a1.714,1.714,0,0,0,0-2.507L12.745,17.3l8.909-8.955a1.714,1.714,0,0,0,0-2.507,1.776,1.776,0,0,0-2.545,0L8.745,15.867a2.155,2.155,0,0,0,0,2.866Z" transform="translate(-8.2 -5.3)" fill="#0059a5"/></svg>
                        </NavLink>}
                    </span>
                </nav>}

            </article>
            
        </React.Fragment>
    
    );
    
}
  
export default SingleSeguranca;